<template>
  <div class="case-category-content">
    <div class="toolbar">
      <el-input
        v-model="searchQuery"
        placeholder="搜索分类名称..."
        style="width: 300px"
        @input="filterData"
        clearable
      >
        <template #prefix>
          <el-icon><Search /></el-icon>
        </template>
      </el-input>
      <el-button type="primary" @click="filterData">查询</el-button>
      <el-button type="primary" @click="showAddModal">新增分类</el-button>
    </div>

    <el-table :data="filteredList" style="width: 100%" border>
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="name" label="分类名称"></el-table-column>
      <el-table-column prop="icon" label="图标/图片" width="120">
        <template #default="scope">
          <el-image
            v-if="scope.row.icon"
            :src="storageSrc(scope.row.icon)"
            style="width: 50px; height: 50px"
            fit="cover"
          ></el-image>
          <span v-else>暂无图片</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template #default="scope">
          <el-button type="primary" size="small" @click="editItem(scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click="deleteItem(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      v-model="showModal"
      :title="isEditing ? '编辑案例分类' : '新增案例分类'"
      width="500px"
    >
      <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px">
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="formData.name" placeholder="请输入分类名称"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="closeModal">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitting">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { Search } from '@element-plus/icons-vue'
import {
  getCaseCategoryList,
  addCaseCategory,
  updateCaseCategory,
  deleteCaseCategory
} from '@/api/index'
import { getStorageFileUrl } from '@/utils/upload'

export default {
  name: 'CaseCategory',
  components: {
    Search
  },
  data() {
    return {
      searchQuery: '',
      showModal: false,
      isEditing: false,
      list: [],
      filteredList: [],
      submitting: false,
      formData: {
        id: null,
        name: ''
      },
      rules: {
        name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    storageSrc(path) {
      return getStorageFileUrl(path)
    },
    parseApiListPayload(res) {
      const d = res?.data
      if (!d) return []
      if (Array.isArray(d)) return d
      if (Array.isArray(d.list)) return d.list
      if (Array.isArray(d.data)) return d.data
      if (Array.isArray(d.items)) return d.items
      return []
    },
    async loadData() {
      try {
        const res = await getCaseCategoryList()
        this.list = this.parseApiListPayload(res)
        this.filteredList = [...this.list]
      } catch (error) {
        console.error('加载数据失败:', error)
        this.$message.error('加载数据失败')
      }
    },
    filterData() {
      if (!this.searchQuery) {
        this.filteredList = [...this.list]
      } else {
        this.filteredList = this.list.filter((item) =>
          String(item.name || '')
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase())
        )
      }
    },
    showAddModal() {
      this.isEditing = false
      this.formData = {
        id: null,
        name: ''
      }
      this.showModal = true
    },
    editItem(item) {
      this.isEditing = true
      this.formData = { ...item }
      this.showModal = true
    },
    async deleteItem(id) {
      this.$confirm('确定要删除这条记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          try {
            await deleteCaseCategory(id)
            await this.loadData()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          } catch (error) {
            console.error('删除失败:', error)
            this.$message.error('删除失败!')
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    async handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        this.submitting = true
        try {
          if (this.isEditing) {
            await updateCaseCategory(this.formData)
            this.$message.success('编辑成功!')
          } else {
            await addCaseCategory(this.formData)
            this.$message.success('新增成功!')
          }
          await this.loadData()
          this.closeModal()
        } catch (error) {
          console.error('操作失败:', error)
          this.$message.error(this.isEditing ? '编辑失败!' : '新增失败!')
        } finally {
          this.submitting = false
        }
      })
    },
    closeModal() {
      this.showModal = false
      this.formData = {
        id: null,
        name: ''
      }
    }
  }
}
</script>

<style scoped>
.case-category-content {
  height: 100%;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
}
</style>
